import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  optionalNameSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';

export const createOperatorSchema = yup.object().shape({
  name: requiredNameSchema,
  organization_id: yup.string(),
  partner_id: yup.string().required(requiredErrorMessage),

  google_places_id: addOptionalNullableToSchema(yup.string()),
  street: requiredNameSchema,
  suite: optionalNameSchema,
  city: requiredNameSchema,
  state: stateSchema.required(requiredErrorMessage),
  zip_code: zipSchema.required(requiredErrorMessage),
  county: optionalNameSchema,
});
